import * as React from 'react';

const MeetingRoomSearch = () => {
  return <div />;
};

export default MeetingRoomSearch;
